import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import { cameraButtonsStyle as style } from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import getCurrentCamera from 'helpers/cameras/getCurrentCamera'
import { checkOfflineLimitsAction } from 'actions/applicationActions'

const mapStateToProps = ({ cameras }) => {
  return {
    currentCamera: getCurrentCamera(cameras)
  }
}

class CameraButtons extends React.Component {
  state = { showOptionList: false }

  componentDidMount = _ =>
    window.addEventListener('click', this.windowClick)

  componentWillUnmount = _ => {
    window.removeEventListener('click', this.windowClick)
  }
  windowClick = event => {
    if (this.state.showOptionList) {
      if (this.refs.optionListButton.contains(event.target)) return
      this.setState({ showOptionList: false })
    }
  }

  render() {
    const { state: { showOptionList }, props: { currentCamera, openCameraPanel,
      checkOfflineLimitsAction, classes } } = this
    const { model, userUploadedSceneUrl, isMultiImager, imagerId } = currentCamera

    if (isMultiImager) {
      return (
        <div className={classes.bottomBar}>
          <div className={classes.buttonWrapper}>
            <div onClick={openCameraPanel('selectModel')} className={classes.buttonRight}>
              Edit Model
            </div>
            <div onClick={openCameraPanel('editConfig')} className={classes.editConfigButton}>
              <FontAwesomeIcon icon='cog' />
              <p>Settings</p>
            </div>
            <div onClick={_ => this.setState({ showOptionList: !showOptionList })} className={showOptionList ? classes.moreButtonSelected : classes.moreButton} ref='optionListButton'>
              <FontAwesomeIcon icon='ellipsis-v' />
            </div>
            {
              showOptionList &&
              <div className={classes.addList}>
                <div onClick={openCameraPanel('wiringPanel')}>
                  <FontAwesomeIcon icon='network-wired' className={classes.icon} />
                  <span>Cabling</span>
                </div>
                <div onClick={_ => checkOfflineLimitsAction('createCamera')}>
                  <FontAwesomeIcon icon='video' className={classes.icon} />
                  <span>Add New Camera</span>
                </div>
              </div>
            }
          </div>
        </div>
      )
    }

    return (
      <div className={classes.bottomBar}>
        <div className={classes.buttonWrapper}>
          <div onClick={openCameraPanel('selectModel')} className={model ? classes.editModelButton : classes.selectModelButton}>
            {model ? `Edit Model` : `Select Model`}
          </div>
          <div onClick={openCameraPanel('simulatedView')} className={model && !userUploadedSceneUrl ? classes.simulatedViewButtonSelect : classes.simulatedViewButtonBoth}>
            <FontAwesomeIcon icon={['far', 'image']} />
            <p>View</p>
            { userUploadedSceneUrl && <FontAwesomeIcon className={classes.setIcon} icon='check' /> }
          </div>
          <div onClick={openCameraPanel('editConfig')} className={classes.editConfigButton}>
            <FontAwesomeIcon icon='cog' />
            <p>Settings</p>
          </div>
          <div onClick={_ => this.setState({ showOptionList: !showOptionList })} className={showOptionList ? classes.moreButtonSelected : classes.moreButton} ref='optionListButton'>
            <FontAwesomeIcon icon='ellipsis-v' />
          </div>
          {
            showOptionList &&
            <div className={classes.addList}>
              <div onClick={openCameraPanel('simulatedPerson')}>
                <FontAwesomeIcon icon='portrait' className={classes.icon} />
                <span>Simulated Person</span>
              </div>
              { !imagerId &&
                <div onClick={openCameraPanel('wiringPanel')}>
                  <FontAwesomeIcon icon='network-wired' className={classes.icon} />
                  <span>Cabling</span>
                </div>
              }
              <div onClick={_ => checkOfflineLimitsAction('createCamera')}>
                <FontAwesomeIcon icon='video' className={classes.icon} />
                <span>Add New Camera</span>
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { checkOfflineLimitsAction })(injectSheet(style)(CameraButtons))



// WEBPACK FOOTER //
// ./src/components/BottomBar/Buttons/cameraButtons.js